import { ofType } from 'redux-observable';
import {
  catchError, map, mergeMap, of, switchMap,
} from 'rxjs';
import { ajax } from 'rxjs/ajax';
import {
  LOAD_FEATURE_GEOMETRY,
  LOAD_FEATURE_POPUP,
  loadFeatureGeometry,
  loadFeatureGeometryFailure,
  loadFeatureGeometrySuccess,
  loadFeaturePopup,
  loadFeaturePopupFailure,
  loadFeaturePopupSuccess,
  SELECT_FEATURE,
} from '../ducks/actions/feature.js';

const selectFeatureEpic = action$ => action$.pipe(
  ofType(SELECT_FEATURE),
  map(action => action.payload),
  mergeMap((data) => {
    const actions = [];
    if (data.properties.typoLink) {
      actions.push(loadFeaturePopup(
        data.properties.typoLink,
        data.teasersEndpoint,
      ));
    }
    if (data.properties.hasGeometry) {
      actions.push(loadFeatureGeometry(
        data.properties.id,
        data.geometryEndpoint,
      ));
    }
    return actions;
  }),
);

const loadFeaturePopupEpic = action$ => action$.pipe(
  ofType(LOAD_FEATURE_POPUP),
  map(action => action.payload),
  switchMap((data) => {
    const teaserUrl = `${data.teasersEndpoint}?typoLink=${encodeURIComponent(data.typoLink)}`;
    return ajax({
      method: 'GET',
      url: teaserUrl,
      responseType: 'html',
    }).pipe(
      map(response => response.response),
      map(popupHtml => loadFeaturePopupSuccess(popupHtml)),
      catchError(error => of(loadFeaturePopupFailure(error))),
    );
  }),
);

const loadFeatureGeometryEpic = action$ => action$.pipe(
  ofType(LOAD_FEATURE_GEOMETRY),
  map(action => action.payload),
  switchMap((data) => {
    const geometryUrl = `${data.geometryEndpoint}?id=${encodeURIComponent(data.id)}`;
    return ajax.getJSON(geometryUrl).pipe(
      map(geoJson => loadFeatureGeometrySuccess(geoJson)),
      catchError(error => of(loadFeatureGeometryFailure(error))),
    );
  }),
);

export const featureActions = [
  selectFeatureEpic,
  loadFeaturePopupEpic,
  loadFeatureGeometryEpic,
];
